import { render } from "./FortuneFab.vue?vue&type=template&id=0a7250d4&scoped=true"
import script from "./FortuneFab.vue?vue&type=script&lang=js"
export * from "./FortuneFab.vue?vue&type=script&lang=js"

import "./FortuneFab.vue?vue&type=style&index=0&id=0a7250d4&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0a7250d4"]])

export default __exports__